export default __webpack_public_path__ + "static/media/CertifiablyDiverse-Platform-min.cb15e8a7.png";